import { MAP_TYPES } from '@deck.gl/carto';

const BROWARDZONINGDISTRICT_SOURCE_ID = 'browardZoningDistrictSource';

const source = {
  id: BROWARDZONINGDISTRICT_SOURCE_ID,
  type: MAP_TYPES.TABLE,
  connection: 'bmpo-smartmetro-09142026',
  data: `us-con-gcp-npr-0000424-011325.diamond.Broward_County_Zoning`,
};

export default source;
